import React from 'react';
import {ServiceRedirect} from "../archers_services/ServiceRedirect";
import {NotificationSnackBar} from "./NotificationSnackBar";


const CustomNotifMessage = (props) => {
  let notif = ''
  if (props.warr !== undefined && props.warr !== '') {
    return <NotificationSnackBar message={props.warr} variant='warning' clean={props.clean}  />
  }
  if (props.data !== undefined && props.data.error !== '' && props.data.error !== undefined
    && props.data.isInvalideToken === true) {
    return (<ServiceRedirect link='/login'/>);

  } else {
    notif = (props.data !== undefined && props.data.error !== '' && props.data.error !== undefined) ?
      <NotificationSnackBar  message={props.data.error} clean={props.clean} variant='error'/> :
      (props.data !== undefined && props.data.message !== '' && props.data.message !== undefined) ?
        <NotificationSnackBar message={props.data.message} init={props.init} clean={props.clean} variant='success'/> :
        '';
    return (notif);
  }

};


export {CustomNotifMessage}
